import React from 'react';
import styled from 'styled-components';
import { WebPushSubItem } from './WebPushSubItem';
export const WebPushSubList = ({ webpushSubs, updateWebpushSub, deleteWebpushSub, }) => {
    if (webpushSubs.length === 0)
        return null;
    return (React.createElement(Wrapper, null, webpushSubs.map((sub) => (React.createElement(WebPushSubItem, { key: sub.auth, webpushSub: sub, updateWebpushSub: updateWebpushSub, deleteWebpushSub: deleteWebpushSub })))));
};
const Wrapper = styled.div `
  display: flex;
  flex-wrap: wrap;
  background-color: white;
  padding-top: 1rem;
  padding-bottom: 1rem;
  gap: 0.6rem;
  font-size: 0.9rem;
`;
